import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="go-footer" id="contact">
      <div className="go-container go-footer__grid">
        <div>
          <p className="go-section-label">Start Your Journey</p>
          <h2>Talk to Vedanskrix Global Opportunities.</h2>
          <p className="go-footer__text">
            Personalized support for study abroad, work visa, visitor visa, documentation review,
            and interview readiness with a more structured process.
          </p>
          <div className="go-footer__links">
            <Link to="/">Home</Link>
            <Link to="/destinations">Destinations</Link>
            <Link to="/services">Services</Link>
            <Link to="/process">Process</Link>
            <Link to="/success">Success</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>

        <div className="go-footer__card">
          <div>
            <span className="go-footer__meta">Phone</span>
            <a href="tel:+918758637022">+91 87586 37022</a>
          </div>
          <div>
            <span className="go-footer__meta">Email</span>
            <a href="mailto:info@vedanskrix.com">info@vedanskrix.com</a>
          </div>
          <div>
            <span className="go-footer__meta">Office</span>
            <p>Vastral, Ahmedabad, Gujarat</p>
          </div>
          <a
            className="go-footer__button"
            href="https://wa.me/918758637022"
            target="_blank"
            rel="noreferrer"
          >
            Chat on WhatsApp
          </a>
        </div>
      </div>

      <div className="go-container go-footer__bottom">
        <p>Vedanskrix Global Opportunities</p>
        <p>Study. Work. Travel. Grow globally.</p>
      </div>
    </footer>
  );
}

export default Footer;
